import tw from "twin.macro";
import React from "react";

export type SectionTitleProps = {
  children: React.ReactNode;
  /** `muted` = gris (réglages) · `primary` = vert (historiques). */
  tone?: "muted" | "primary";
};

function SectionTitle({ children, tone = "muted" }: SectionTitleProps) {
  return (
    <p
      css={[
        tw`text-xs font-semibold uppercase tracking-wide px-2 pb-2 pt-1`,
        tone === "primary" ? tw`text-primary-800` : tw`text-gray-400`,
      ]}
    >
      {children}
    </p>
  );
}

export default SectionTitle;
